export const RECEIPT_CANCELED = -1
export const RECEIPT_PENDING = 0
export const RECEIPT_COMPLETE = 1

export const Statuses = [
  {
    code: RECEIPT_CANCELED,
    label: 'Canceled',
    color: 'red',
    icon: 'fas fa-times-circle'
  },
  {
    code: RECEIPT_PENDING,
    label: 'Pending',
    color: 'orange',
    icon: 'fas fa-question-circle'
  },
  {
    code: RECEIPT_COMPLETE,
    label: 'Completed',
    color: 'green',
    icon: 'fas fa-check-circle'
  }
]

export default Statuses



// WEBPACK FOOTER //
// ./src/utils/statuses/receipt.js